import React from 'react'

// components
import RegistrationStep from 'components/register/shared/RegistrationStep'
import Loading from 'components/atoms/Loading'
import Typography from '@mui/material/Typography'

// containers
import Form from 'components/account/Parents/Form'

const EditParent = props => {
  const { queryLoading, mutationLoading, form } = props

  return (
    <RegistrationStep>
      <Typography pb={4} variant='h2' align='center'>
        Edit Parent / Guardian
      </Typography>
      {!form || queryLoading ? (
        <Loading />
      ) : (
        <Form
          buttonText={mutationLoading ? 'Saving…' : 'Save'}
          editMode
          {...props}
        />
      )}
    </RegistrationStep>
  )
}

export default EditParent
